import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { BaseFormComponent } from '../../base-form.component';
import { FormService } from '../../../../services/form/form.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  moduleId: module.id,
  selector: 'radio-group',
  templateUrl: './radio-group.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioGroupComponent),
      multi: true,
    },
  ],
})
export class RadioGroupComponent extends BaseFormComponent implements OnInit, ControlValueAccessor {
  @Input() propertyName: string;
  @Input() modifierClasses: string;
  @Input() valueOptions?: Array<object>;
  @Input() formGroupComponent?: boolean;
  selectedItem: string;
  options: Array<any>;
  radioGroupName: string;
  isError: boolean = false;
  showTitle = false;

  onChange;
  onTouched;

  constructor(formService: FormService) {
    super();
    this.formService = formService;
  }

  ngOnInit() {
    super.ngOnInit();
    this.prop = this.propertyName;
    this.radioGroupName = this.prop;
    this.componentId = this.prop;
    this.updateFromModel();
  }

  updateFromModel() {
    this.setOptions();

    if (!this.formGroupComponent) {
      let value = this.getValue(this.prop);

      //don't coerce null into "null"
      if (value !== null && value !== undefined) {
        value = value + '';
      }

      if (value !== this.selectedItem) {
        this.selectedItem = value;
      }
    }
  }

  setOptions() {
    const prop = this.prop;

    if (this.valueOptions !== undefined && this.valueOptions.length > 0) {
      this.options = this.valueOptions;
    } else {
      const values: any = this.formService.getValuesFor(prop);
      const descriptionsObj = this.formService.getDescriptionsFor(prop);
      if (!this.areOptionsDifferent(values)) {
        return;
      }

      if (this.options) {
        this.options.length = 0;
      } else {
        this.options = [];
      }

      values.forEach((val) => {
        const description = typeof descriptionsObj[val] === 'object' ? descriptionsObj[val].text : descriptionsObj[val];
        this.options.push({
          value: val,
          description: description,
        });
      });
    }
  }

  public areOptionsDifferent(values) {
    if (!this.options || !values) {
      return true;
    }
    if (this.options.length !== values.length) {
      return true;
    }
    let ret = false;
    for (let i = 0; i < this.options.length; i++) {
      ret = ret || this.options[i].value !== values[i];
    }
    return ret;
  }

  async trigger() {
    if (!this.formGroupComponent) {
      this.isError = !(await this.validateAndSet(this.prop, this.selectedItem));
    }
    if (this.onChange && this.onTouched) {
      this.onChange();
      this.onTouched();
      this.value = this.selectedItem;
    }
    this.valueChanged.emit();
  }

  set value(value: string) {
    this.onChange(value);
    this.onTouched();
  }

  get value(): string {
    return this.selectedItem;
  }

  registerOnChange(fn): void {
    this.onChange = fn;
  }

  registerOnTouched(fn): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    // this.disableConditionally = isDisabled;
  }

  writeValue(value): void {
    if (value) {
      this.selectedItem = value;
    }
  }
}
